import React from 'react';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import { Breadcrumb } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import SelectPrintable from '../components/wizard/printable-steps/select-printable.js';
import SelectPrintableContent from '../components/wizard/printable-steps/select-content.js';
import SavePrintable from '../components/wizard/printable-steps/save-printable.js';

export default class Printable extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    getBreadCrumb() {

        return <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={'ui-779'} defaultMessage={''} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={'ui-781'} defaultMessage={''} />
            </Breadcrumb.Item>
        </Breadcrumb>
    }


    render() {
        let steps = [SelectPrintable, SelectPrintableContent, SavePrintable];

        return (<Layout>{this.getBreadCrumb()}<Wizard name="" stepsNavigation={true} steps={steps} /></Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/printable.js